<template>
  <footer class="site-footer" :style="cssVars">
    <div class="site-footer__inner">
      <div class="site-footer__copy">
        <strong>{{ site.brand }}</strong>
        <p>{{ site.footerText }}</p>
      </div>
      <div class="site-footer__meta">
        <a :href="'mailto:' + site.email">{{ site.email }}</a>
        <a :href="site.linkedin" target="_blank" rel="noreferrer">LinkedIn</a>
      </div>
    </div>
  </footer>
</template>

<script>
import site from "../siteContent";

export default {
  data() {
    return { site };
  },
  computed: {
    cssVars() {
      return {
        "--brand-primary": this.site.palette.primary,
        "--brand-secondary": this.site.palette.secondary
      };
    }
  }
};
</script>

<style scoped lang="scss">
.site-footer {
  position: relative;
  z-index: 2;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(6, 12, 22, 0.92);
}

.site-footer__inner {
  width: min(1180px, calc(100% - 2rem));
  margin: 0 auto;
  padding: 1.35rem 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.site-footer__copy strong {
  display: block;
  margin-bottom: 0.45rem;
  color: #fff;
  font-family: "Space Grotesk", sans-serif;
}

.site-footer__copy p {
  margin: 0;
  max-width: 34rem;
  color: rgba(234, 241, 248, 0.7);
}

.site-footer__meta {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  text-align: right;
}

.site-footer__meta a {
  color: rgba(234, 241, 248, 0.82);
  text-decoration: none;
}

@media (max-width: 720px) {
  .site-footer__inner {
    flex-direction: column;
    align-items: flex-start;
  }

  .site-footer__meta {
    text-align: left;
  }
}
</style>
